<ng-container *ngIf="resolveLoader">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    <!-- <div class="matSpinner">
    <mat-spinner></mat-spinner>
</div> -->
</ng-container>

<router-outlet></router-outlet>